class Keyboard {
  constructor() {
    this.pressedKeys = new Set();
    this.justPressed = new Set();

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);

    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  }

  handleKeyDown(event) {
    const key = event.key.toLowerCase();

    // only trigger once per press
    if (!this.pressedKeys.has(key)) {
      this.justPressed.add(key);
    }

    this.pressedKeys.add(key);
  }

  handleKeyUp(event) {
    const key = event.key.toLowerCase();
    this.pressedKeys.delete(key);
  }

  isDown({ key }) {
    return this.pressedKeys.has(key.toLowerCase());
  }

  isJustPressed({ key }) {
    return this.justPressed.has(key.toLowerCase());
  }

  endFrame() {
    // call once per frame
    this.justPressed.clear();
  }

  destroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
  }
}

export { Keyboard };
